import BlockContent from './BlockContent';

export default BlockContent;
